
// @flow

const _ = require('lodash');

import moment from 'moment';

export const DATE_FORMAT = 'DD.MM.YYYY';
export const momentRepr = _.partial(moment, _, DATE_FORMAT, true);
export const momentReprExtend = { repr: { moment: momentRepr } };

export type MomentRepr = {
	moment: (dateString: string) => moment
}
